import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow } from '@mui/material';
import FinancialProductSeasonalityTemplatesTableRow from './FinancialProductSeasonalityTemplatesTableRow';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';
const FinancialProductSeasonalityTemplatesTableBody = ({
  canWrite,
  seasonalityTemplates,
  onEdit,
  onChangeData,
  onCloseEdit,
  onSave,
  onDelete,
  lockControls,
  financialProductSeasonalityTemplatesDictionary,
  financialProductSeasonalityTemplatesValidation
}) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(financialProductSeasonalityTemplatesValidation) &&
        !seasonalityTemplates?.find((_, index) => {
          return !isValid(financialProductSeasonalityTemplatesValidation[index]);
        }) && (
          <TableRow>
            <Typography color='error'>{t('FinancialProduct.Details.SeasonalityTemplates.ValidationList')}</Typography>
          </TableRow>
        )}
      {seasonalityTemplates?.map((seasonalityTemplate, index) => {
        return (
          <FinancialProductSeasonalityTemplatesTableRow
            canWrite={canWrite}
            key={seasonalityTemplate.seasonalityTemplateId}
            index={index}
            seasonalityTemplate={seasonalityTemplate}
            onEdit={onEdit}
            onChangeData={onChangeData}
            onCloseEdit={onCloseEdit}
            onSave={onSave}
            onDelete={onDelete}
            lockControls={lockControls}
            financialProductSeasonalityTemplatesDictionary={financialProductSeasonalityTemplatesDictionary}
            financialProductSeasonalityTemplatesValidation={financialProductSeasonalityTemplatesValidation}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductSeasonalityTemplatesTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  seasonalityTemplates: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onChangeData: PropTypes.func.isRequired,
  lockControls: PropTypes.bool.isRequired,
  financialProductSeasonalityTemplatesDictionary: PropTypes.array.isRequired,
  financialProductSeasonalityTemplatesValidation: PropTypes.object.isRequired
};

export default FinancialProductSeasonalityTemplatesTableBody;
